import React from "react";
import "./style.css";

function Nav() {
    return (
        <div>
            <nav className="navbar">
                <span className="navbar-brand mb-0 h1">Employee Directory</span>
            </nav>
        </div>
    );
}

export default Nav;
